const PENDING_VERIFY_EMAIL_KEY = 'sahib:pending-verify-email';

export function getPendingVerifyEmail(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage.getItem(PENDING_VERIFY_EMAIL_KEY);
  } catch {
    return null;
  }
}

export function setPendingVerifyEmail(email: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(PENDING_VERIFY_EMAIL_KEY, email);
  } catch {
    // sessionStorage unavailable — silently degrade.
  }
}

export function clearPendingVerifyEmail(): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(PENDING_VERIFY_EMAIL_KEY);
  } catch {
    // ignore
  }
}
